import { Injectable } from '@angular/core';
import { INgxGridColumn } from 'ngx-primeng-grid';

import {
  INgxManageLayout, INgxManageLayoutSetting,
  INgxManageLayoutSettingAddOption, INgxManageLayoutForm
} from '../models/ngx-manage-layout.model';
import { NgxUtility } from '../../core/_utility/utility';

@Injectable({
  providedIn: 'root'
})
export class NgxManageLayoutService {

  constructor() { }

  process(manageJson: any): INgxManageLayout {
    if (manageJson) {
      const obj = manageJson as INgxManageLayout;
      const result: INgxManageLayout = {
        api: obj.api,
        columns: this.processColumn(obj.columns),
        setting: this.processSetting(obj.setting),
        form: this.processForm(obj.form)
      }
      return result;
    }
    return null;
  }

  private processColumn(columns: INgxGridColumn[]): INgxGridColumn[] {
    if (columns && columns.length > 0) {
    }
    return columns;
  }

  private processSetting(setting: INgxManageLayoutSetting): INgxManageLayoutSetting {
    return {
      pageTitle: setting.pageTitle,
      addOption: this.getAddOption(setting.addOption),
      enableSearch: NgxUtility.hasProperty(setting, 'enableSearch') ? setting.enableSearch : true,
      perPage: NgxUtility.hasProperty(setting, 'perPage') ? setting.perPage : 10,
      pk: setting.pk,
      layoutId: NgxUtility.hasProperty(setting, 'layoutId') ? setting.layoutId : null,
      saveSearch: NgxUtility.hasProperty(setting, 'saveSearch') ? setting.saveSearch : true,
      actionMode: NgxUtility.hasProperty(setting, 'actionMode') ? setting.actionMode : 'block',
      defaultSortColumn: NgxUtility.hasProperty(setting, 'defaultSortColumn') ? setting.defaultSortColumn : null,
      defaultSortOrder: NgxUtility.hasProperty(setting, 'defaultSortOrder') ? setting.defaultSortOrder : -1,
    }
  }

  private getAddOption(option: INgxManageLayoutSettingAddOption): INgxManageLayoutSettingAddOption {
    if (option) {
      return {
        enable: NgxUtility.hasProperty(option, 'enable') ? option.enable : false,
        label: NgxUtility.hasProperty(option, 'label') ? option.label : null,
        mode: NgxUtility.hasProperty(option, 'mode') ? option.mode : null,
        link: NgxUtility.hasProperty(option, 'link') ? option.link : null,
        modalTitle: NgxUtility.hasProperty(option, 'modalTitle') ? option.modalTitle : null,
        modalWidth: NgxUtility.hasProperty(option, 'modalWidth') ? option.modalWidth : 'auto',
      }
    }
    return null;
  }

  private processForm(form: INgxManageLayoutForm): INgxManageLayoutForm {
    return {
      actions: NgxUtility.hasProperty(form, 'actions') ? form.actions : [],
      controls: NgxUtility.hasProperty(form, 'controls') ? form.controls : [],
      confirmations: NgxUtility.hasProperty(form, 'confirmations') ? form.confirmations : [],
    }
  }
}
